// Mock data for Emotional Intelligence Academy

export const ageBooks = [
  { age: 2, title: "Age 2: First Feelings", focus: "Parent-led regulation, body rules, early feeling recognition, repair routines", amazonLink: "https://www.amazon.com/dp/B0GPLSZL5Z", color: "bg-accent-green-200" },
  { age: 3, title: "Age 3: My Body, My Words", focus: "Shared regulation, simple child scripts, transition skills, impulse control", amazonLink: "https://www.amazon.com/dp/B0GPM5DFZW", color: "bg-accent-grey-200" },
  { age: 4, title: "Age 4: Foundations", focus: "Feelings language, body cues, calm tools, boundaries", amazonLink: "https://www.amazon.com/dp/B0GKHLC1DG", color: "bg-accent-purple-200" },
  { age: 5, title: "Age 5: Building Awareness", focus: "Naming emotions, recognizing body signals, simple regulation", amazonLink: "https://www.amazon.com/gp/product/B0GKHSMDHV?ref_=dbs_m_mng_rwt_calw_tkin_1&storeType=ebooks", color: "bg-accent-blue-200" },
  { age: 6, title: "Age 6: Communication Basics", focus: "Using words for feelings, asking for help, sharing space", amazonLink: "https://www.amazon.com/gp/product/B0GKX154X5?ref_=dbs_m_mng_rwt_calw_tkin_2&storeType=ebooks", color: "bg-accent-orange-200" },
  { age: 7, title: "Age 7: Repair & Responsibility", focus: "Apology skills, making amends, understanding impact", amazonLink: "https://www.amazon.com/gp/product/B0GKYZR3WX?ref_=dbs_m_mng_rwt_calw_tkin_3&storeType=ebooks", color: "bg-accent-pink-200" },
  { age: 8, title: "Age 8: Conflict Skills", focus: "I-statements, negotiation, handling disagreements", amazonLink: "https://www.amazon.com/gp/product/B0GKZ4PPNQ?ref_=dbs_m_mng_rwt_calw_tkin_4&storeType=ebooks", color: "bg-accent-green-200" },
  { age: 9, title: "Age 9: Friendship Navigation", focus: "Reading social cues, inclusion, managing peer dynamics", amazonLink: "https://www.amazon.com/gp/product/B0GLL229BG?ref_=dbs_m_mng_rwt_calw_tkin_5&storeType=ebooks", color: "bg-accent-grey-200" },
  { age: 10, title: "Age 10: Voice & Advocacy", focus: "Assertive communication, standing up for self and others", amazonLink: "https://www.amazon.com/gp/product/B0GM28ZJBC?ref_=dbs_m_mng_rwt_calw_tkin_6&storeType=ebooks", color: "bg-accent-purple-200" },
  { age: 11, title: "Age 11: Emotional Complexity", focus: "Multiple emotions, nuanced feelings, emotional literacy", amazonLink: "https://amazon.com", color: "bg-accent-blue-200" },
  { age: 12, title: "Age 12: Identity Foundations", focus: "Values, integrity, understanding who you are", amazonLink: "https://amazon.com", color: "bg-accent-orange-200" },
  { age: 13, title: "Age 13: Social Pressure", focus: "Peer influence, consent, boundaries in relationships", amazonLink: "https://amazon.com", color: "bg-accent-pink-200" },
  { age: 14, title: "Age 14: Digital Life", focus: "Online boundaries, digital communication, social media", amazonLink: "https://amazon.com", color: "bg-accent-green-200" },
  { age: 15, title: "Age 15: Self-Respect", focus: "Self-worth, body autonomy, relationship standards", amazonLink: "https://amazon.com", color: "bg-accent-grey-200" },
  { age: 16, title: "Age 16: Conflict Patterns", focus: "Recognizing cycles, healthy repair, relationship skills", amazonLink: "https://amazon.com", color: "bg-accent-purple-200" },
  { age: 17, title: "Age 17: Leadership", focus: "Emotional influence, supporting others, community", amazonLink: "https://amazon.com", color: "bg-accent-blue-200" },
  { age: 18, title: "Age 18: Transition & Independence", focus: "Adult relationships, life transitions, emotional resilience", amazonLink: "https://amazon.com", color: "bg-accent-orange-200" }
];

export const ageCategories = {
  earlyStart: { ages: [2, 3], label: "Early Start (Ages 2-3)", description: "First feelings, co-regulation, body awareness, early self-control" },
  foundations: { ages: [4, 5, 6, 7], label: "Foundations (Ages 4-7)", description: "Feelings language, body cues, calm tools, boundaries, repair" },
  communication: { ages: [8, 9, 10, 11, 12], label: "Communication & Conflict (Ages 8-12)", description: "Assertive voice, I-statements, negotiation, unfairness, friendship skills" },
  teenSkills: { ages: [13, 14, 15, 16, 17, 18], label: "Teen Skills (Ages 13-18)", description: "Social pressure, consent, self respect, conflict patterns, digital life, integrity" }
};

export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    role: "Parent of 6-year-old",
    text: "Finally, a curriculum that gives me the exact words to use! No more guessing how to handle big emotions. The weekly structure makes it so manageable.",
    rating: 5
  },
  {
    id: 2,
    name: "Jennifer L.",
    role: "Homeschool Mom",
    text: "We've tried so many social-emotional resources, but this is the only one with a real sequence. My kids are actually using the regulation tools without me prompting them.",
    rating: 5
  },
  {
    id: 3,
    name: "Michael T.",
    role: "Father of 10 and 13-year-old",
    text: "The age-specific approach is brilliant. What works for my 10-year-old is completely different from my teen, and this curriculum gets that.",
    rating: 5
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Why Scripts Matter More Than You Think",
    excerpt: "Learn why having exact language to use during conflict and big emotions can transform your parenting approach.",
    date: "2024-12-15",
    author: "EI Academy Team",
    category: "Parenting Tips",
    image: "https://images.unsplash.com/photo-1758598737883-aee5195ae1da",
    slug: "why-scripts-matter"
  },
  {
    id: 2,
    title: "Starting at Your Child's Current Age: A Guide",
    excerpt: "Should you start at Age 4 or jump to your child's current age? Here's how to decide and what to expect.",
    date: "2024-12-10",
    author: "EI Academy Team",
    category: "Getting Started",
    image: "https://images.unsplash.com/photo-1713942590283-59867d5e3f8d",
    slug: "starting-current-age"
  },
  {
    id: 3,
    title: "The 40-Week Structure: Why It Works",
    excerpt: "Emotional skills aren't learned in a weekend workshop. Here's why a year-long sequence makes the difference.",
    date: "2024-12-05",
    author: "EI Academy Team",
    category: "Curriculum Design",
    image: "https://images.unsplash.com/photo-1551498800-17cbc39c85bb",
    slug: "40-week-structure"
  },
  {
    id: 4,
    title: "Regulation Tools That Actually Stick",
    excerpt: "Why most calming strategies don't work and how repeated practice changes everything.",
    date: "2024-11-28",
    author: "EI Academy Team",
    category: "Emotional Regulation",
    image: "https://images.unsplash.com/photo-1766973117841-e919298728e1",
    slug: "regulation-tools"
  },
  {
    id: 5,
    title: "Teen Years: When Emotional Intelligence Matters Most",
    excerpt: "The teenage curriculum focuses on identity, boundaries, and relationships. Here's what makes it different.",
    date: "2024-11-20",
    author: "EI Academy Team",
    category: "Teen Development",
    image: "https://images.unsplash.com/photo-1651906068265-178d2480cb8c",
    slug: "teen-emotional-intelligence"
  },
  {
    id: 6,
    title: "Daily Practice in 10 Minutes or Less",
    excerpt: "How to fit emotional skills practice into your busiest days without adding overwhelm.",
    date: "2024-11-15",
    author: "EI Academy Team",
    category: "Time Management",
    image: "https://images.unsplash.com/photo-1769201153045-98827f62996b",
    slug: "daily-practice-10-minutes"
  }
];

export const faqs = [
  {
    question: "Is this therapy?",
    answer: "No. This is educational content designed for home use. These are skills and practice activities for parents to guide. If your child needs therapeutic support, this curriculum can complement that work but does not replace professional mental health treatment."
  },
  {
    question: "Do I need a psychology background?",
    answer: "Absolutely not. The curriculum includes scripts, clear instructions, and simple daily practice activities. You don't need specialized training—just a willingness to practice alongside your child."
  },
  {
    question: "How long are the daily lessons?",
    answer: "Lessons are designed to be short—around 5-10 mins daily or 1 longer session per week. This curriculum is built for busy families, not endless worksheets."
  },
  {
    question: "What if my child has big behaviors or meltdowns?",
    answer: "Start where you are. Keep practice sessions brief and calm. The curriculum includes regulation tools practiced repeatedly so they become accessible during stress. If behaviors are severe or unsafe, consider working with a professional alongside this curriculum."
  },
  {
    question: "Do I start at Age 4 or my child's current age?",
    answer: "Start at your child's current age. The books are built for that developmental stage. If you notice gaps in foundational skills, you can always reference earlier ages for specific tools, but you don't need to start from scratch."
  },
  {
    question: "Where can I buy the books?",
    answer: "All books are available on Amazon in both paperback and Kindle formats. Each age-specific book page includes a direct link to the Amazon listing."
  },
  {
    question: "Can I use this with multiple children?",
    answer: "Yes! Each book is age-specific, so if you have children at different ages, you'll want the corresponding book for each child. The structure is consistent across ages, making it easier to implement with multiple kids."
  },
  {
    question: "What's included in each book?",
    answer: "Each book includes: a full 40-week curriculum with weekly skill targets, parent-guided scripts for real situations, regulation tools your child can practice, daily lessons designed for busy families, and clear progression that builds over time."
  }
];

export const ageBookDetails = {
  2: {
    title: "First Feelings",
    tagline: "Parent-led regulation and routine installation",
    intro: "At 2, the child borrows your nervous system and your structure. The Age 2 curriculum is designed to reduce chaos by making your responses predictable and body-based, with weekly targets that build progressively throughout the 40-week sequence.",
    topics: [
      "Safer body rules (hands safe, stop throwing, step back)",
      "Tiny pause and wait skills (freeze 1 second, wait 3-5 seconds)",
      "Early feeling recognition (happy, sad, mad, scared) through parent narration",
      "Early body awareness through naming cues (tight hands, hot face, loud voice)",
      "Replacement behaviors (hands to me, show me want, try again)",
      "Basic social foundations (soft hands, space, wave/hi entry, parent-led toy conflict)",
      "Fast recovery and repair routines (safe now, hug or space, help fix it)"
    ],
    skills: [
      "Prevent meltdowns using body basics, early cues, short scripts, and short transitions",
      "Hold boundaries with fewer words and less escalation",
      "Run a repeatable reset and repair routine after hard moments",
      "Parent co-regulation foundations and feeling labels through narration",
      "Micro self-control through games and social body rules"
    ],
    scripts: {
      calmVoice: [
        "\"You're safe. I'm here.\"",
        "\"Hands to me. One breath.\""
      ],
      boundary: [
        "\"Hands safe.\"",
        "\"Stop throwing. Step back.\""
      ],
      repair: [
        "\"Safe now. Hug or space?\"",
        "\"Help fix it.\""
      ],
      conflict: [
        "\"Show me what you want.\"",
        "\"Try again with soft hands.\""
      ]
    },
    units: [
      "Parent co-regulation foundations",
      "Feeling labels through parent narration",
      "Transitions, autonomy, and 'no' without escalation",
      "Micro self-control through games",
      "Social foundations, mostly body rules",
      "Repair, integration, and maintenance plan"
    ]
  },
  3: {
    title: "My Body, My Words",
    tagline: "Shared regulation plus simple child scripts",
    intro: "At 3, language and social awareness grow, but self-control still collapses under stress. The Age 3 curriculum shifts from mostly parent-run routines to the child beginning to use tiny skills with your prompts, with weekly targets that build progressively throughout the 40-week sequence.",
    topics: [
      "Stronger transition skills (countdown, first-then, choice within boundary)",
      "Clearer 'no' tolerance with support and short scripts",
      "More active impulse control and waiting (freeze/stop body, timers, short waits)",
      "Simple communication scripts (help please, can I play, stop space, my turn/your turn)",
      "Early conflict options (trade, wait, choose another)",
      "Social safety skills (gentle hands, personal space, joining play, listening routine)",
      "Public behavior routines with support (hand rule, job, exit plan)",
      "Deeper repair routines (repair without forced apology, repair menu, action amends)"
    ],
    skills: [
      "Cue skills briefly instead of narrating everything",
      "Use fewer words during meltdowns and more structure outside of them",
      "Coach short social scripts and keep safety consistent",
      "Child begins labeling feelings and body signals",
      "Tiny self-control skills (impulse, waiting, frustration tolerance)"
    ],
    scripts: {
      calmVoice: [
        "\"Stop. Breathe. Now try again.\"",
        "\"Your body is telling you something.\""
      ],
      boundary: [
        "\"Use your words: help please.\"",
        "\"Hands to yourself. Step back.\""
      ],
      repair: [
        "\"Let's fix it. What can you do?\"",
        "\"Repair menu: help, hug, or fix.\""
      ],
      conflict: [
        "\"My turn, your turn. Let's trade.\"",
        "\"Use your words: can I play?\""
      ]
    },
    units: [
      "Regulation foundations + family routines (child starts participating more)",
      "Feeling words + body signals (child begins labeling too)",
      "Transitions + boundaries + 'no'",
      "Tiny self-control skills (impulse, waiting, frustration)",
      "Social skills for real life",
      "Repair, integration, independence within limits"
    ]
  },
  4: {
    title: "Emotional Foundations",
    tagline: "Naming feelings, body signals, safe boundaries",
    intro: "The Age 4 curriculum focuses on emotional language, co-regulation, and the earliest building blocks of empathy and repair, with weekly targets that build progressively throughout the 40-week sequence.",
    topics: [
      "Naming core feelings and body signals",
      "Basic calm-down tools with parent support",
      "Feelings vs behavior (feelings allowed, unsafe behavior stopped)",
      "Early empathy with boundaries (care without fixing)",
      "Repair after conflict (safe, shame-free repair)"
    ],
    skills: [
      "Daily feeling check-ins with simple words",
      "Calm-down tool practice with you leading",
      "Short scripts for big moments (mad, sad, scared)",
      "Parent-child dialogue practice during calm time",
      "Weekly reflection and wrap-up"
    ],
    scripts: {
      calmVoice: [
        "\"Hands pause. One breath.\"",
        "\"You can choose safe actions.\""
      ],
      boundary: [
        "\"Hands are for keeping bodies safe.\"",
        "\"Hands pause.\""
      ],
      repair: [
        "\"Messing up happens. Repair is the skill.\"",
        "\"Repair means you fix what happened and rebuild trust.\""
      ],
      conflict: [
        "\"Hands pause. One breath.\"",
        "\"Ask: 'Are you okay?'\""
      ]
    }
  },
  5: {
    title: "Big Feelings, Better Choices",
    tagline: "Frustration tolerance, early empathy, repair skills",
    intro: "The Age 5 curriculum focuses on more independence in regulation, impulse control, friendship skills, empathy with boundaries, and stronger repair, with weekly targets that build progressively throughout the 40-week sequence.",
    topics: [
      "Expanded feeling words and mixed feelings",
      "Earlier body awareness and tool selection",
      "Waiting, transitions, and restarting after dysregulation",
      "Impulse control: pause, choose safe actions, handle \"no\"",
      "Friendship scripts: join play, compromise, handle rude words",
      "Empathy without people-pleasing, plus jealousy and exclusion skills",
      "Repair skills: specific apologies and making amends"
    ],
    skills: [
      "Daily feeling and body check-ins",
      "Calm-down tool selection practice (child chooses)",
      "Scenario-based skill application (school and peers)",
      "Parent-child dialogue practice with real scripts",
      "Weekly reflection and wrap-up"
    ],
    scripts: {
      calmVoice: [
        "\"Hands pause. One breath.\"",
        "\"Today we focus on repair.\""
      ],
      boundary: [
        "\"Hands pause, then choose a safe action.\"",
        "\"You chose a safe action.\""
      ],
      repair: [
        "\"I'm sorry for __.\"",
        "\"Repair means you fix what happened and rebuild trust.\""
      ],
      conflict: [
        "\"What happened, what now?\"",
        "\"Choose a repair action: fix, help, return/replace.\""
      ]
    }
  },
  6: {
    title: "Independence and Peer Skills",
    tagline: "Impulse control, friendship communication, conflict repair",
    intro: "The Age 6 curriculum focuses on regulation in real life, stronger communication, group and peer dynamics, integrity, worry skills, and confident self-advocacy, with weekly targets that build progressively throughout the 40-week sequence.",
    topics: [
      "Early warning signs and acting sooner (zones, timelines)",
      "Fast support requests for school and public settings",
      "Teasing, exclusion, group conflict, and safe exits",
      "Truth, responsibility, guilt vs shame, and bigger repair options",
      "Worry as a body signal, brave steps with a plan",
      "Handling criticism and asking for help, space, or clarification"
    ],
    skills: [
      "Daily state check-ins (calm, building, too big)",
      "Short tool practice for fast resets",
      "Scenario practice for school moments (teasing, pressure, conflict)",
      "Parent-child script rehearsal for advocacy and repair",
      "Weekly reflection and wrap-up"
    ],
    scripts: {
      calmVoice: [
        "\"Ouch, breathe, ask what to do next.\"",
        "\"Ouch, breathe, try again.\""
      ],
      boundary: [
        "\"Not doing that.\"",
        "\"Is someone unsafe?\" (decision check)"
      ],
      repair: [
        "\"Tell the truth, then repair.\"",
        "\"I made a mistake.\" (reframe)"
      ],
      conflict: [
        "\"What happened, what now?\" (routine)",
        "\"Find a helper adult + space first.\" (group conflict)"
      ]
    }
  },
  7: {
    title: "Follow-Through and Group Dynamics",
    tagline: "Responsibility systems, group conflict repair, self-advocacy",
    intro: "The Age 7 curriculum focuses on stronger self-regulation and follow-through, advanced communication and conflict skills, group dynamics, values, and resilience, with weekly targets that build progressively throughout the 40-week sequence.",
    topics: [
      "Regulating under pressure and following through on plans",
      "Conflict skills that work in groups, not just one-on-one",
      "Friendship depth, group behavior, and social dynamics",
      "Integrity, responsibility, and values-based choices",
      "Worry, confidence, and resilient thinking",
      "End-of-year integration and identity anchor"
    ],
    skills: [
      "Daily check-ins for stress and state",
      "Tool practice for faster recovery and follow-through",
      "Scenario-based group conflict practice",
      "Parent-child dialogue practice for problem-solving and repair",
      "Weekly reflection and wrap-up"
    ],
    scripts: {
      calmVoice: [
        "\"New plan, same calm.\"",
        "\"Pressure reset.\" (breathe + body release)"
      ],
      boundary: [
        "\"I need __, please.\"",
        "\"I like you and I can say no.\""
      ],
      repair: [
        "\"Pause, name impact, try again.\"",
        "\"Full repair steps: name impact, amends, new plan.\""
      ],
      conflict: [
        "\"What did you mean?\"",
        "\"I heard you say __, right?\""
      ]
    }
  },
  8: {
    title: "Conflict Skills",
    tagline: "I-statements, negotiation, handling disagreements",
    intro: "The Age 8 curriculum focuses on strategic self-regulation, communication that works during disagreements, negotiation tools, deeper friendship skills, integrity, and resilience, with weekly targets that build progressively throughout the 40-week sequence.",
    topics: [
      "Self-regulation with strategy (catch it early, prevent escalation)",
      "Clear conflict communication (including I-statements and calm requests)",
      "Negotiation, compromise, and handling disagreements respectfully",
      "Friendship depth and social complexity in groups",
      "Integrity and responsibility when it is uncomfortable",
      "Worry, confidence, and resilience skills",
      "Integration, leadership, and identity anchor"
    ],
    skills: [
      "Daily feeling and stress check-ins",
      "Calm-down tool practice and early-interruption practice",
      "Scenario-based negotiation and disagreement practice",
      "Parent-child dialogue practice using scripts",
      "Weekly reflection and wrap-up"
    ],
    scripts: {
      calmVoice: [
        "\"Pause, plan, try again.\"",
        "\"What can I learn?\" (mistake data)"
      ],
      boundary: [
        "\"That doesn't work for me.\"",
        "\"Pause, space, return.\" (time plan)"
      ],
      repair: [
        "\"Micro-repair: name impact + one apology line + next step.\"",
        "\"Invite, listen, decide together.\" (leadership)"
      ],
      conflict: [
        "\"I disagree because __.\"",
        "\"I feel __, I need __, can we __?\""
      ]
    }
  },
  9: {
    title: "Executive Skills and Social Ethics",
    tagline: "Planning and focus, direct communication, rumor resistance",
    intro: "The Age 9 curriculum focuses on stress, executive skills, stronger repair, belonging and social complexity, integrity, and identity resilience, with weekly targets that build progressively throughout the 40-week sequence.",
    topics: [
      "Self-regulation under stress plus executive skills support",
      "Communication, debate control, and repair skills",
      "Friendship, belonging, and handling complex peer situations",
      "Integrity, responsibility, and character growth",
      "Identity and resilience through comparison and social pressure",
      "Integration, leadership, and identity anchor"
    ],
    skills: [
      "Daily check-ins for stress and capacity",
      "Tool practice for recovery and refocus",
      "Scenario-based repair and communication practice",
      "Parent-child dialogue practice for decision-making",
      "Weekly reflection and wrap-up"
    ],
    scripts: {
      calmVoice: [
        "\"Pressure routine: breathe, cue, begin.\"",
        "\"Boredom plan: start small, reward, finish.\""
      ],
      boundary: [
        "\"I'm done talking about this now.\"",
        "\"Option A/Option B, pick one.\""
      ],
      repair: [
        "\"My part + amends.\" (routine)",
        "\"Pause, plan, revisit.\" (time routine)"
      ],
      conflict: [
        "\"I see it differently.\"",
        "\"Help me understand.\""
      ]
    }
  },
  10: {
    title: "Preteen Life Skills",
    tagline: "Capacity planning, healthy disagreement, digital boundaries",
    intro: "The Age 10 curriculum focuses on independence and life systems, negotiation and perspective, social ethics, accountability, and resilience for preteen life, with weekly targets that build progressively throughout the 40-week sequence.",
    topics: [
      "Self-regulation with independence and life systems",
      "Perspective-taking, negotiation, and stronger communication",
      "Friendship, belonging, and social ethics",
      "Integrity, responsibility, and accountability",
      "Identity resilience and mental skills for preteen pressure",
      "Integration, leadership, and identity anchor"
    ],
    skills: [
      "Daily check-ins for stress, energy, and load",
      "Tool practice for refocus and recovery",
      "Scenario-based negotiation and ethical decision practice",
      "Parent-child dialogue practice for boundaries and repair",
      "Weekly reflection and wrap-up"
    ],
    scripts: {
      calmVoice: [
        "\"Pause, label, choose.\" (under pressure)",
        "\"Body basics checklist: sleep, fuel, move.\""
      ],
      boundary: [
        "\"I'm not discussing this.\" + exit plan",
        "\"Device boundary plan: time, place, purpose.\""
      ],
      repair: [
        "\"That sounded __, I meant __.\"",
        "\"Repair cycle: notice, own, act, follow-up.\""
      ],
      conflict: [
        "\"My point, my evidence, my request.\" (one sentence each)",
        "\"Let me try again.\""
      ]
    }
  },
  11: {
    title: "Middle School Readiness",
    tagline: "Stress regulation, friend boundaries, confidence under pressure",
    intro: "The Age 11 curriculum focuses on middle school readiness, identity and boundaries, social pressure, values under pressure, and mood resilience, with weekly targets that build progressively throughout the 40-week sequence.",
    topics: [
      "Self-regulation for middle school transitions and pressure",
      "Communication, identity development, and boundary skills",
      "Friendship, belonging, and social pressure navigation",
      "Integrity and values when peers push limits",
      "Mind and mood resilience skills",
      "Integration, leadership, and identity anchor"
    ],
    skills: [
      "Daily check-ins for mood, stress, and triggers",
      "Tool practice for fast recovery and regulation",
      "Scenario-based peer pressure and boundary practice",
      "Parent-child dialogue practice for values and repair",
      "Weekly reflection and wrap-up"
    ],
    scripts: {
      calmVoice: [
        "\"Mood swing plan: notice, normalize, choose support.\"",
        "\"Pause + tone reset + repair routine.\""
      ],
      boundary: [
        "\"That's not for me.\" + exit line",
        "\"Pause 20 minutes + consult a trusted adult if unsure.\""
      ],
      repair: [
        "\"That came out wrong, I meant __.\"",
        "\"What we agree to next time.\" (routine)"
      ],
      conflict: [
        "\"I disagree about __, I respect you.\"",
        "\"Short clarify + stop the story.\" (one sentence, then exit)"
      ]
    }
  },
  12: {
    title: "Early Adolescent Resilience",
    tagline: "Mood tools, peer pressure skills, privacy and consent",
    intro: "The Age 12 curriculum focuses on early adolescence regulation, identity and boundaries, relationships and peer pressure, moral identity, and resilience, with weekly targets that build progressively throughout the 40-week sequence.",
    topics: [
      "Self-regulation for early adolescence and higher intensity emotions",
      "Communication, identity, and boundary skills",
      "Social life, relationships, and peer pressure plans",
      "Integrity, responsibility, and moral identity development",
      "Mind skills, self-concept, and resilience",
      "Integration, leadership, and identity anchor"
    ],
    skills: [
      "Daily check-ins for stress, mood, and self-awareness",
      "Tool practice for interruption and recovery",
      "Scenario-based relationship and peer pressure practice",
      "Parent-child dialogue practice for boundaries, consent, and repair",
      "Weekly reflection and wrap-up"
    ],
    scripts: {
      calmVoice: [
        "\"Activation check: fight, freeze, shutdown, then choose tool.\"",
        "\"Recharge plan: micro-breaks + recovery.\""
      ],
      boundary: [
        "\"No thanks + short reason + repeat.\"",
        "\"Clarify once, then disengage.\" (one sentence, then stop)"
      ],
      repair: [
        "\"Own impact + apology + change plan.\"",
        "\"Boundary first, then respectful tone, then repair.\""
      ],
      conflict: [
        "\"State, listen, restate.\" (routine)",
        "\"I need help with __. Can we __?\""
      ]
    }
  }
};

export const freeResources = [
  {
    id: 1,
    title: "Free Sample Week (Age 4)",
    description: "Get a complete week of curriculum including one script page and one practice page to see exactly how the program works.",
    type: "PDF Download",
    icon: "BookOpen"
  },
  {
    id: 2,
    title: "Repair Phrase Script Cards",
    description: "Downloadable cards with specific language for apologies, making amends, and repair after conflict.",
    type: "Printable Cards",
    icon: "MessageSquare"
  },
  {
    id: 3,
    title: "Calm Voice Script Cards",
    description: "Exact phrases to use when emotions are high and you need to help your child regulate in the moment.",
    type: "Printable Cards",
    icon: "Heart"
  },
  {
    id: 4,
    title: "Feelings Vocabulary Chart by Age",
    description: "Age-appropriate feelings words organized by developmental stage (4-7, 8-12, 13-18).",
    type: "Chart",
    icon: "List"
  }
];
